import { refundBooking } from 'actions/booking';
import { showAlert } from 'actions/client';
import moment from 'moment';
import React from 'react';
import Loader from 'react-overlay-loader/lib/Loader';
import { connect } from 'react-redux';
import {
  accentForCurrency,
  multiplyValueForCurrency,
} from 'utils/currency/currency-utils';
import ArrowRight from 'utils/images/arrow-right.svg';
import { callAPI } from 'utils/network';
import { fetchCompletedBookings } from '../../../../actions/booking';
import {
  GetProductStatisticsAPIRequest,
  GetSalesStatisticsAPIRequest,
} from '../../../../utils/constants/network';
import DateSelectorPill from '../shared/DateSelectorPill';
import './index.scss';

class SalesPanel extends React.Component {
  state = {
    fromMmt: moment().subtract(1, 'weeks').startOf('day'),
    toMmt: moment().subtract(1, 'second').add(1, 'hour').startOf('hour'),
    fetchingProductStats: false,
    fetchingSalesStats: false,
    page: 0,
    productStats: [],
    salesStats: {},
  };

  // Lifecycle

  async fetchProductStats() {
    this.setState({ fetchingProductStats: true });

    const { fromMmt, toMmt, page } = this.state;

    try {
      const apiRequest = GetProductStatisticsAPIRequest({
        from: fromMmt.toISOString(),
        to: toMmt.toISOString(),
        limit: 10,
        skip: page * 10,
      });
      const productStats = await callAPI(apiRequest);

      this.setState({ productStats });
    } catch (e) {
      console.error(e);
      // this.props.showAlert(
      //   'Failure',
      //   'Sorry, we could not get product sales data.'
      // );
    }
    this.setState({ fetchingProductStats: false });
  }

  async fetchSalesStats() {
    this.setState({ fetchingSalesStats: true });

    const { fromMmt, toMmt } = this.state;
    try {
      const apiRequest = GetSalesStatisticsAPIRequest({
        from: fromMmt.toISOString(),
        to: toMmt.toISOString(),
      });
      const salesStats = await callAPI(apiRequest);

      this.setState({ salesStats });
    } catch (e) {
      console.error(e);
      // this.props.showAlert('Failure', 'Sorry, we could not get sales data.');
    }

    this.setState({ fetchingSalesStats: false });
  }

  componentWillMount() {
    this.fetchProductStats();
    this.fetchSalesStats();
    // const { page } = this.state;
    // this.props.fetchCompletedBookings("", page);
  }

  updateFrom(component, value) {
    const newMmt = this.modifyMmt(this.state.fromMmt, value, component);
    this.setState({ fromMmt: newMmt }, () => {
      this.fetchProductStats();
      this.fetchSalesStats();
    });
  }

  updateTo(component, value) {
    const newMmt = this.modifyMmt(this.state.toMmt, value, component);
    this.setState({ toMmt: newMmt }, () => {
      this.fetchProductStats();
      this.fetchSalesStats();
    });
  }

  modifyMmt(originalMmt, newMmt, component) {
    let mmt = originalMmt.clone();

    if (component === 'time') {
      mmt = mmt.set({
        hour: newMmt.get('hour'),
        minute: newMmt.get('minute'),
        second: newMmt.get('second'),
      });
    } else {
      let newerMmt = newMmt.clone();
      newerMmt = newerMmt.set({
        hour: mmt.get('hour'),
        minute: mmt.get('minute'),
        second: mmt.get('second'),
      });

      return newerMmt;
    }

    return mmt;
  }

  changePage(newPage) {
    if (newPage < 0) {
      return;
    }
    if (this.state.productStats.length < 10 && this.state.page < newPage) {
      return;
    }

    this.setState({ page: newPage }, () => {
      this.fetchProductStats();
    });
  }

  render() {
    const {
      fetchingProductStats,
      fetchingSalesStats,
      productStats,
      salesStats,
      page,
    } = this.state;
    const { venue } = this.props;

    return (
      <React.Fragment>
        <div className="panel__content">
          <div className="top__bar">
            <h2 className="panel__title">Stats</h2>
          </div>

          <div className="sales__header tabb__shadow">
            <div className="sales__search__section">
              <div className="sales__search__date__row">
                <span style={{ marginRight: 8 }} className="small__label">
                  From
                </span>
                <DateSelectorPill
                  type="date"
                  value={this.state.fromMmt}
                  onChange={newVal => this.updateFrom('date', newVal)}
                  style={{ marginRight: 5 }}
                >
                  22/02/2021
                </DateSelectorPill>
                <DateSelectorPill
                  type="time"
                  value={this.state.fromMmt}
                  onChange={newVal => this.updateFrom('time', newVal)}
                  style={{ marginRight: 30 }}
                >
                  00:00
                </DateSelectorPill>
              </div>
              <div className="sales__search__date__row">
                <span className="small__label" style={{ marginRight: 8 }}>
                  To
                </span>
                <DateSelectorPill
                  type="date"
                  value={this.state.toMmt}
                  onChange={newVal => this.updateTo('date', newVal)}
                  style={{ marginRight: 5 }}
                >
                  23/02/2021
                </DateSelectorPill>
                <DateSelectorPill
                  type="time"
                  value={this.state.toMmt}
                  onChange={newVal => this.updateTo('time', newVal)}
                  style={{ marginRight: 50 }}
                >
                  23/02/2021
                </DateSelectorPill>
              </div>
            </div>
            <div className="sales__splitter" />
            <div
              className={`sales__stats__section${
                !venue.tips_enabled ? ' sales__stats__section--no-tips' : ''
              }`}
            >
              <Loader text="" loading={fetchingSalesStats} />

              <div className="sales__stats__section__stat">
                <div className="small__label">Orders</div>
                <h2 style={{ margin: 0, marginTop: 8 }}>
                  {salesStats.num_orders || '...'}
                </h2>
              </div>

              <div className="sales__stats__section__stat">
                <div className="small__label">Products Sold</div>
                <h2 style={{ margin: 0, marginTop: 8 }}>
                  {salesStats.total_sold || '...'}
                </h2>
              </div>

              {venue.tips_enabled && (
                <div className="sales__stats__section__stat">
                  <div className="small__label">Tip Amount</div>
                  <h2 style={{ margin: 0, marginTop: 8 }}>
                    {salesStats.total_tips
                      ? `${accentForCurrency(venue.currency)}${(
                          salesStats.total_tips /
                          multiplyValueForCurrency(venue.currency)
                        ).toFixed(2)}`
                      : '...'}
                  </h2>
                </div>
              )}

              <div className="sales__stats__section__stat">
                <div className="small__label">Revenue</div>
                <h2 style={{ margin: 0, marginTop: 8 }}>
                  {salesStats.total
                    ? `${accentForCurrency(venue.currency)}${(
                        salesStats.total /
                        multiplyValueForCurrency(venue.currency)
                      ).toFixed(2)}`
                    : '...'}
                </h2>
              </div>

              {venue.enable_vat && (
                <div className="sales__stats__section__stat">
                  <div className="small__label">Total VAT</div>
                  <h2 style={{ margin: 0, marginTop: 8 }}>
                    {salesStats.total_vat
                      ? `${accentForCurrency(venue.currency)}${(
                          salesStats.total_vat /
                          multiplyValueForCurrency(venue.currency)
                        ).toFixed(2)}`
                      : '...'}
                  </h2>
                </div>
              )}

              {/* <div className="sales__stats__section__stat">
                <div className="small__label">Total Profit</div>
                <h2 style={{ margin: 0, marginTop: 8 }}>
                  {salesStats.total_profit !== null &&
                  salesStats.total_profit !== undefined
                    ? `${accentForCurrency(venue.currency)}${(
                        salesStats.total_profit /
                        multiplyValueForCurrency(venue.currency)
                      ).toFixed(2)}`
                    : '...'}
                </h2>
              </div> */}
            </div>
          </div>

          <div className="table__container" style={{ position: 'relative' }}>
            <Loader text="" loading={fetchingProductStats} />

            <table className="fold-table">
              <thead>
                <tr className="fold-table__header-row">
                  <th style={{ width: '80%', paddingLeft: 20 }}>Product</th>
                  <th style={{ width: '10%' }}>Sales</th>
                  <th style={{ width: '10%' }}>Revenue</th>
                </tr>
              </thead>
              <tbody>
                {!productStats || productStats.length === 0 ? (
                  <tr className="view view__no__hover">
                    <td colSpan={3}>No sales data right now.</td>
                  </tr>
                ) : null}
                {productStats.map(productStat => (
                  <tr className="view view__no__hover" key={productStat.name}>
                    <td style={{ width: '80%', paddingLeft: 20 }}>
                      {productStat.name}
                    </td>
                    <td style={{ width: '10%' }}>{productStat.total_sold}</td>
                    <td style={{ width: '10%' }}>{`${accentForCurrency(
                      venue.currency
                    )}${(
                      productStat.revenue /
                      multiplyValueForCurrency(venue.currency)
                    ).toFixed(2)}`}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr />
              </tfoot>
            </table>

            <div className="pagination__container">
              <div
                style={{ cursor: page === 0 ? 'auto' : 'pointer' }}
                onClick={() => this.changePage(page - 1)}
                className="arrow__container"
              >
                <img
                  style={{ opacity: page === 0 ? 0.2 : 1 }}
                  alt="paginate left"
                  className="arrow__left"
                  src={ArrowRight}
                ></img>
              </div>
              <div className="page__number">Page {page + 1}</div>
              <div
                style={{
                  cursor: productStats.length < 10 ? 'auto' : 'pointer',
                }}
                onClick={() => this.changePage(page + 1)}
                className="arrow__container"
              >
                <img
                  style={{ opacity: productStats.length < 10 ? 0.2 : 1 }}
                  alt="paginate right"
                  src={ArrowRight}
                ></img>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  venue: state.venue,
  completedBookings: state.booking.completedBookings,
  fetchingCompletedBookings: state.booking.fetchingCompletedBookings,
  completedBookingsFetched: state.booking.compeltedBookingsFetched,
  bookingRefunded: state.booking.bookingRefunded,
  refundingBooking: state.booking.refundingBooking,
});

const mapDispatchToProps = dispatch => ({
  showAlert: (title, desc) => dispatch(showAlert(title, desc)),
  fetchCompletedBookings: (query, page) =>
    dispatch(fetchCompletedBookings(query, page)),
  refundBooking: id => dispatch(refundBooking(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SalesPanel);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Sales/index.jsx